import { render, staticRenderFns } from "./WithTitle.vue?vue&type=template&id=66905ea2"
import script from "./WithTitle.vue?vue&type=script&lang=js"
export * from "./WithTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports